var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import React, { useEffect, useState } from "react";
import actions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import { useSelector } from "react-redux";
import BodyLayout from "./BodyLayout";
import FooterLayout from "./FooterLayout";
import useDraftOrderDetails from "@frameworks/NCD/Hook/Draft/useDraftOrderDetails";
import TypeButton from "../../OrderBook/Components/Type/TypeButton";
import Loader from "@frameworks/shared-library/components/Loader";
import useDraftOrderDeclarations from "@frameworks/NCD/Hook/Draft/useDraftDeclarations";
import { useIsinClientDetails } from "@frameworks/NCD/Hook/TransactionJourney/useIsinClientDetails";
import { useSaveOrder } from "@frameworks/NCD/Hook/TransactionJourney/useSaveOrder";
import { alphabetsColorsConfigMap } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
import Header from "@frameworks/NCD/Components/OpenSearch";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
var TransactionJourney = function (_a) {
    var _b, _c, _d;
    var visible = _a.visible, setVisible = _a.setVisible, onClickCancel = _a.onClickCancel, onClickContinue = _a.onClickContinue, paymentLoading = _a.loading, onSelectClient = _a.onSelectClient;
    var searchParams = new URLSearchParams(location.search);
    var _e = __read(useState("mobile"), 2), selectedOption = _e[0], setSelectedOption = _e[1];
    var _f = __read(useState(""), 2), mobileNo = _f[0], setMobileNo = _f[1];
    var _g = __read(useState(""), 2), selectedDate = _g[0], setSelectedDate = _g[1];
    var _h = __read(useState(""), 2), email = _h[0], setEmail = _h[1];
    var _j = __read(useState(false), 2), isError = _j[0], setIsError = _j[1];
    var _k = __read(useState({}), 2), error = _k[0], setError = _k[1];
    var _l = __read(useState(false), 2), emailError = _l[0], setEmailError = _l[1];
    var cActions = new actions();
    var _m = useIsinClientDetails(selectedOption, email || mobileNo || selectedDate), IsinClientDetailsErrorData = _m.errorData, setErrorData = _m.setErrorData, loading = _m.loading;
    var _o = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), transactionDetails = _o.transactionDetails, selectedClientDetails = _o.selectedClientDetails;
    var _p = useSaveOrder(), handleSaveOrder = _p.handleSaveOrder, saveOrderLoader = _p.loading;
    var _q = useDraftOrderDetails(), loader = _q.loader, errorData = _q.errorData;
    var draftDeclarations = useDraftOrderDeclarations().loader;
    var _r = __read(useState(false), 2), isCxoFlow = _r[0], setIsCxoFlow = _r[1];
    var handleReset = function () {
        setErrorData({ error: null, isOpen: false });
        onClickCancel();
        cActions.resetValue();
        cActions.updateClientDetails(null);
        cActions.updateTransactionData({
            dpDetails: "",
            quantity: "",
            dirtyPrice: "",
        });
        cActions.updateTransactionId(null);
        cActions.saveDraftOrder({
            requestid: "",
            success: false,
            message: "",
            statuscode: "",
            errors: "",
            data: {
                message: "",
                status: "",
                trx_id: "",
            },
        });
        cActions.isinClientDetails({
            requestid: "",
            success: false,
            message: "",
            statuscode: "",
            errors: "",
            data: null,
        });
        if (typeof searchParams !== "undefined") {
            var url = window.location.pathname;
            window.history.replaceState(null, "", url);
        }
    };
    useEffect(function () {
        if (errorData.isOpen) {
            setVisible(false);
        }
    }, [errorData.isOpen]);
    useEffect(function () {
        if (!(selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.ispansearch)) {
            setEmail("");
            setMobileNo("");
            setSelectedDate("");
        }
    }, [selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.ispansearch]);
    return (React.createElement(GenericSidebar, { parentClassname: "primary-aif-pms-sidebar-container d-flex flex-column otc-trx-journey", header: (selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.ispansearch) ? (React.createElement(Header, { title: "Enter client details", subText: "Client matching this PAN needs additional details" })) : (React.createElement("div", { className: "read-more-tooltip align-items-center aif-pms-genericScheme-d" },
            React.createElement(GenericSchemeName, { name: capitalizeFirstLetter(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.ncdName), maxWidth: 305, showTooltip: false, showImage: true, wrap: true, parentClassName: "ncd-transaction-sidebar", customSubTextComp: React.createElement("div", { className: "d-flex gap-10 align-items-center" },
                    React.createElement("span", { className: "DMSanN_14_300 txt_blue-light3 fw-300" }, transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.isin),
                    React.createElement(TypeButton, { text: transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.buySellFlag })), textAndBackgroundColorCollectionConfig: alphabetsColorsConfigMap }))), body: (loader && draftDeclarations) || saveOrderLoader ? (React.createElement(Loader, null)) : (React.createElement(React.Fragment, null,
            React.createElement(BodyLayout, { onSelectClient: onSelectClient, IsinClientDetailsErrorData: IsinClientDetailsErrorData, setErrorData: setErrorData, isCxoFlow: isCxoFlow, setIsCxoFlow: setIsCxoFlow, selectedOption: selectedOption, setSelectedOption: setSelectedOption, mobileNo: mobileNo, setMobileNo: setMobileNo, selectedDate: selectedDate, setSelectedDate: setSelectedDate, email: email, setEmail: setEmail, isError: isError, setIsError: setIsError, error: error, setError: setError, emailError: emailError, setEmailError: setEmailError }),
            React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                    ((_b = IsinClientDetailsErrorData.error) === null || _b === void 0 ? void 0 : _b.status) === "FAILURE" ? (React.createElement("span", { className: "edel-icon-red-cross rounded-circle" })) : (React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" })),
                    React.createElement("span", { className: "DMSans_13_400 txt_white-smoke3" }, (_c = IsinClientDetailsErrorData.error) === null || _c === void 0 ? void 0 : _c.message)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: (email || mobileNo || selectedDate) &&
                    ((_d = IsinClientDetailsErrorData.error) === null || _d === void 0 ? void 0 : _d.status) === "FAILURE"
                    ? true
                    : false, setClose: function () {
                    setErrorData({ error: null, isOpen: false });
                }, autohide: true, parentClassName: "otc-product-bouquet-toast" }))), footer: React.createElement(FooterLayout, { onClickCancel: handleReset, IsinClientDetailsErrorData: IsinClientDetailsErrorData, setIsCxoFlow: setIsCxoFlow, isCxoFlow: isCxoFlow, handleSaveOrder: handleSaveOrder, loader: (selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.isClientPan) ? loading : saveOrderLoader, selectedOption: selectedOption, setSelectedOption: setSelectedOption, mobileNo: mobileNo, setMobileNo: setMobileNo, selectedDate: selectedDate, setSelectedDate: setSelectedDate, email: email, setEmail: setEmail, isError: isError, setIsError: setIsError, error: error, setError: setError, emailError: emailError, setEmailError: setEmailError }), openKey: visible, setOpenKey: setVisible, arrowClose: true, delay: 10, blurBackground: true, onSideBarClose: handleReset, parentIcon: "edel-icon-close" }));
};
export default TransactionJourney;
